module.exports = __webpack_public_path__ + "media/images/top-search-bg-2-9fc30514d11ad674148cdac657402da0.png";